import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';

var PeriodicAccountReviewModalComponent = /** @class */ (function (_super) {
    __extends(PeriodicAccountReviewModalComponent, _super);
    function PeriodicAccountReviewModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    PeriodicAccountReviewModalComponent.prototype.acknowledge = function () {
        return __awaiter(this, void 0, void 0, function () {
            var nowIso, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        nowIso = new Date().toISOString();
                        return [4 /*yield*/, magic.methods.users.updateUserProfile({
                                lastAccountReviewOnUtc: nowIso,
                            })];
                    case 2:
                        _a.sent();
                        this.emitClose();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.log('error', e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    PeriodicAccountReviewModalComponent.prototype.closeModal = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var path, isLinkClicked, nowIso, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = event.composedPath();
                        isLinkClicked = path.some(function (element) {
                            return element instanceof HTMLElement && element.tagName === 'A';
                        });
                        if (!isLinkClicked) {
                            return [2 /*return*/];
                        }
                        nowIso = new Date().toISOString();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.methods.users.updateUserProfile({
                                lastAccountReviewOnUtc: nowIso,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.log('Error', e_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.emitClose();
                        return [2 /*return*/];
                }
            });
        });
    };
    PeriodicAccountReviewModalComponent.prototype.emitClose = function () {
        return true;
    };
    __decorate([
        Emit('close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PeriodicAccountReviewModalComponent.prototype, "emitClose", null);
    PeriodicAccountReviewModalComponent = __decorate([
        Component({
            name: 'corex-periodic-account-review-modal',
        })
    ], PeriodicAccountReviewModalComponent);
    return PeriodicAccountReviewModalComponent;
}(Mixins(MagicConfigMixin)));

export default PeriodicAccountReviewModalComponent;
